import { errorMessagesProxy } from "@/utils/helpers";

export const HOMEPAGE_SEARCH_ERRORS = errorMessagesProxy({
  GENERIC_ERROR: "Sorry, there has been a problem with your search.",
});
